var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.25 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.2891 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75H11.4C12.6601 15.75 13.2902 15.75 13.7715 15.5048C14.1948 15.2891 14.5391 14.9448 14.7548 14.5215C15 14.0402 15 13.4101 15 12.15V9.75M9.75 12.75H5.25M11.25 9.75H5.25M15.091 2.90901C15.9697 3.78769 15.9697 5.21231 15.091 6.09099C14.2123 6.96967 12.7877 6.96967 11.909 6.09099C11.0303 5.21231 11.0303 3.78769 11.909 2.90901C12.7877 2.03033 14.2123 2.03033 15.091 2.90901Z",
    stroke: "##5926F0",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenA);
export default __webpack_public_path__ + "static/media/pen_a.5ccf578dc2ef8be88d9009bb323226a7.svg";
export { ForwardRef as ReactComponent };